import { TRIAL_LENGTHS, UPGRADES, type TrialLength, type UpgradeId } from './balance';

/**
 * The complete, serialisable game state.
 *
 * You always walk one integer at a time, so the set of visited integers is always the
 * contiguous range [minVisited, maxVisited]. Medals, twin pairs and famous numbers are all
 * derived from that range instead of being stored, which keeps saves tiny and impossible
 * to get out of sync.
 */
export interface GameState {
  position: number;
  direction: 1 | -1;
  minVisited: number;
  maxVisited: number;
  points: number;
  lifetimePoints: number;
  /** Integers walked, including revisits. */
  steps: number;
  taps: number;
  upgrades: Record<UpgradeId, number>;
  trialBests: Record<TrialLength, number>;
  playTimeMs: number;
  startedAt: number;
}

export function emptyUpgrades(): Record<UpgradeId, number> {
  return Object.fromEntries(UPGRADES.map((u) => [u.id, 0])) as Record<UpgradeId, number>;
}

export function emptyTrialBests(): Record<TrialLength, number> {
  return Object.fromEntries(TRIAL_LENGTHS.map((t) => [t, 0])) as Record<TrialLength, number>;
}

export function newGame(now = Date.now()): GameState {
  return {
    position: 0,
    direction: 1,
    minVisited: 0,
    maxVisited: 0,
    points: 0,
    lifetimePoints: 0,
    steps: 0,
    taps: 0,
    upgrades: emptyUpgrades(),
    trialBests: emptyTrialBests(),
    playTimeMs: 0,
    startedAt: now,
  };
}
